 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1]

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	var installedChunks = {
 		38: 0
 	};



 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var head = document.getElementsByTagName('head')[0];
 				var script = document.createElement('script');

 				script.charset = 'utf-8';
 				script.timeout = 120000;

 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = __webpack_require__.p + "" + {"0":"43d1f2e4b74d4cfdc71f","1":"c8fc772b29e5e5c8c2b7","2":"dcac9dca195ae83e5ec9","3":"4bf60faf276286461718","4":"884aa4f93261bdd3ef6f","5":"c702f201b890359f3300","6":"85084d69cdc87326dd2a","7":"f4a2b5aaa4d251cdf195","8":"f94e7d58ca477e64a7fe","9":"6d32ff74ca40e7c0f34c","10":"7051c371022c798f4c25","11":"b6e43a4772fcd370e620","12":"d6239a17aaf4f257b2b2","13":"a335ae3e7ab8b9ac61f0","14":"cad8273a14f14bc0a144","15":"5c6a7a0f7584132356d9","16":"fda6077d4864caf71b2f","17":"ee0c1c9a6250deee4ba4","18":"3f79238001728be3cd8b","19":"f24736b44da855830211","20":"140fbfdac2f7181dd832","21":"7ab08268390429b58662","22":"b79a7e3e356abcbadc8e","23":"ab5267e9af16721dfb1d","24":"5a1545d31a7d336d3acf","25":"99986ef3f08861063fd2","26":"a500f8933a80b4b066fe","27":"ae4b1377e509ed5f8aca","28":"a59e42527037b7b73606","29":"8299c5fa50e2d685adef","30":"9ea373bc4a99f3a06133","31":"356abcef6f449179a7ed","32":"08c71b4895e379a0dfb8","33":"0e8afae74842e68693de"}[chunkId] + "/graun." + ({"0":"commercial~enhanced","1":"vendors~commercial~enhanced","2":"ophan-embed","4":"vendors~commercial~facia","5":"vendors~storyquestions-atom","6":"vendors~commonsdivision-atom","7":"vendors~commercial","8":"explainer-atom","9":"timeline-atom","10":"qanda-atom","11":"profile-atom","12":"guide-atom","13":"enhanced","14":"commercial","16":"crosswords~trail","17":"trail","18":"vendors~audio~crosswords~preferences~profile","19":"preferences","20":"vendors~media-player","21":"vendors~audio","22":"commercial-hosted","23":"membership","24":"audio","25":"experiments","26":"youtube","27":"newsletters","28":"profile","29":"football","30":"video-player","31":"media-player","32":"crosswords","33":"facia"}[chunkId]||chunkId) + ".js";
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				function onScriptComplete(event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 409);
